export const pushGTMAnalyticsEvent = (dataLayerObj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerObj);
};
